import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=0890e3fe&"
import script from "./GoodsDetails.vue?vue&type=script&lang=ts&"
export * from "./GoodsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports